import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import { useCanonical } from "./hooks/use-canonical";

const Index = lazy(() => import("./pages/Index"));
const About = lazy(() => import("./pages/About"));
const AboutAarthy = lazy(() => import("./pages/AboutAarthy"));
const Contact = lazy(() => import("./pages/Contact"));
const Programs = lazy(() => import("./pages/Programs"));
const Instruments = lazy(() => import("./pages/Instruments"));
const Insights = lazy(() => import("./pages/Insights"));
const NotFound = lazy(() => import("./pages/NotFound"));
const Downloads = lazy(() => import("./pages/Downloads"));

function CanonicalTag() {
  useCanonical();
  return null;
}

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <CanonicalTag />
        <ScrollToTop />
        <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/about-aarthy" element={<AboutAarthy />} />
            <Route path="/connect" element={<Contact />} />
            <Route path="/contact" element={<Navigate to="/connect" replace />} />
            <Route path="/programs" element={<Navigate to="/about" replace />} />
            <Route path="/programs/:programId" element={<Programs />} />
            <Route path="/team" element={<Navigate to="/about" replace />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/instruments" element={<Instruments />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
